import React from "react";
import "./SnaitheHistoryStart.css";

const SnaitheHistoryStart = () => {
  return (
    <div className="snaithe-history-container">
      <div className="history-title">Snáithe History</div>
      <div className="history-second-title">
        A Journey through History and Innovation: The Legacy of Snáithe
      </div>
      <div className="history-text">
        Introduction Snáithe: A Legacy of Trust and Innovation Across Industries
        <br /> <br />
        The tale of Snáithe, guided by visionary Co-founder and CEO Bilal Mian,
        began to unfold in 1996. This journey started with a young soul from
        Lahore and spanned continents, culminating in Sweden. Within this Nordic
        expanse, education harmoniously blended with entrepreneurial aspirations
        and the burgeoning realm of artificial intelligence.
        <br /> <br />
        The unyielding spirit flowing through Mr. Bilal Mian's lineage, echoing
        the wisdom of his ancestors, led to remarkable triumphs-a testament to
        unwavering resolve.
      </div>
    </div>
  );
};

export default SnaitheHistoryStart;
